import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from "react-toastify";

import "common/css/master.css";

import { saveSubjectDaysPeriodsSvc, resetSubjectDaysPeriodsSvc } from './subjectConstraintSvc';

var vLstSubj = []

const SubjectConstraintTable = (props) => {
    const { tblKey, lstSub, syllabusId, clsId, sectionId, setLoader, setOpacity, lstPeriod, getSubjectDaysPeriodList } = props;

    const [lstSubj, setLstSubj] = useState(lstSub);
    const [subId, setSubId] = useState(0);
    const [filterSub, setFilterSub] = useState('')
    // const [lstSubject, setLstSubject] = useState([]);
    // const [lstPeriod, setLstPeriod] = useState([]);

    useEffect(() => {
        // console.log("useEffect in SubjectConstraintTable component called, lstSub", lstSub);
        // console.log("syllabusId", syllabusId);
        // console.log("sectionId", sectionId);
        // console.log("clsId", clsId);

        // setLstSubj(lstSub);
        vLstSubj = lstSub;
        // console.log(vLstSubj)
    }, [lstSub, syllabusId, clsId, sectionId]);



    const handleDaysOff = (dIdx, pSubId, pChk) => {
        for (let i = 0; i < vLstSubj.length; i++) {
            let obj = vLstSubj[i];
            if (pSubId == obj.subjectId) {
                obj.lstDaysOff[dIdx] = pChk;
                break;
            }
        }
        // console.log(vLstSubj)
        setLstSubj(vLstSubj)
    }

    const handlePeriodsOff = (pIdx, pSubId, pChk) => {
        for (let i = 0; i < vLstSubj.length; i++) {
            let obj = vLstSubj[i];
            if (pSubId == obj.subjectId) {
                obj.lstPeriodsOff[pIdx] = pChk;
                break;
            }
        }
        // console.log(vLstSubj)
        setLstSubj(vLstSubj)
    }

    const saveSubjectDaysPeriod = (pSubId) => {
        // console.log("saveSubjectDaysPeriod called", pSubId, pSubId);
        setLoader("block");
        setOpacity(0.5);
        let tmpObj = vLstSubj.find(item => item.subjectId === pSubId);
        tmpObj.sectionId = sectionId;
        tmpObj.daysOff = tmpObj.lstDaysOff.map(val => val ? '1' : '0').join('');
        tmpObj.periodsOff = tmpObj.lstPeriodsOff.map(val => val ? '1' : '0').join('')
        delete tmpObj['lstDaysOff'];
        delete tmpObj['lstPeriodsOff'];
        delete tmpObj['subject'];
        saveSubjectDaysPeriodsSvc(tmpObj, saveSubjectDaysPeriodResponse);

    };
    const filterSubject = (e) => {
        const keyword = e.target.value.trim();
        if (keyword !== '') {
            const results = lstSub.filter((obj) => {
                return obj.subject.toLowerCase().includes(keyword.toLowerCase());
                // Use the toLowerCase() method to make it case-insensitive
            });
            setLstSubj(results);
        } else {
            setLstSubj(lstSub);
            // If the text field is empty, show all users
        }
        setFilterSub(keyword);
    };

    const saveSubjectDaysPeriodResponse = async (data) => {
        // console.log("saveSubjectDaysPeriodResponse called, data", data);
        if (data.status === "Success") {
            toast.success(data.message);
            getSubjectDaysPeriodList(sectionId);

        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }

    const resetSubjectDaysPeriods = (pSubId) => {
        let tmpObj = vLstSubj.find(item => item.subjectId === pSubId);
        var r = window.confirm("Are you sure to clear the Days off and Periods Off for "+tmpObj.subject+"?")
        if(!r){
            return;
        }
        setLoader("block");
        setOpacity(0.5);
        
        tmpObj.sectionId = sectionId;
        delete tmpObj['lstDaysOff'];
        delete tmpObj['lstPeriodsOff'];
        delete tmpObj['subject'];

        resetSubjectDaysPeriodsSvc(tmpObj, saveSubjectDaysPeriodResponse)
    }
    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };

    const colgrp = <colgroup>
        <col width="15"></col>
        <col width="20"></col>
        <col width="50"></col>
        <col width="10"></col>
    </colgroup>


    return (
        <div >
            <div className="col-md-12 col-xs-12 col-centered padding-remove " >
                <table className="tableLayout1" >
                    {colgrp}
                    <thead>
                        <tr key="trsub_1">
                            <th rowSpan='2'>
                                <input
                                    onChange={filterSubject}
                                    type="text"
                                    value={filterSub}
                                    className="form-control inp-search"
                                    placeholder="Subject" />
                            </th>
                            <th>Days Off</th>
                            <th>Periods Off</th>
                            <th rowSpan='2'>Action</th>
                        </tr>
                        <tr key="trsub_2">
                            <th className="text-center" >
                                <div style={{ display: 'inline-block', margin: '0 2px', height: 20, width: 20 }} className="text-center">M</div>
                                <div style={{ display: 'inline-block', margin: '0 2px', height: 20, width: 20 }} className="text-center">T</div>
                                <div style={{ display: 'inline-block', margin: '0 2px', height: 20, width: 20 }} className="text-center">W</div>
                                <div style={{ display: 'inline-block', margin: '0 2px', height: 20, width: 20 }} className="text-center">T</div>
                                <div style={{ display: 'inline-block', margin: '0 2px', height: 20, width: 20 }} className="text-center">F</div>
                                <div style={{ display: 'inline-block', margin: '0 2px', height: 20, width: 20 }} className="text-center">S</div>
                                <div style={{ display: 'inline-block', margin: '0 2px', height: 20, width: 20 }} className="text-center">S</div>
                            </th>
                            <th>
                                {lstPeriod.map((p, idx) => {
                                    return <div style={{ fontSize: '.85rem', display: 'inline-block', margin: '0 2px', height: 24, width: 24 }} className="text-center">{p.startTm}</div>
                                })}
                            </th>
                        </tr>
                    </thead>
                </table>
                <div className="tableDiv" style={{ height: "60vh" }}>
                    <table className="tableLayout">
                        {colgrp}
                        <tbody id="subjectTeacherTable" >
                            {lstSubj &&
                                lstSubj.map((subject, i) => (
                                    <tr key={'sub_' + subject.subjectId}
                                        onClick={() => setSubId(subject.subjectId)}
                                        className={subject.subjectId === subId ? "selected" : ''}>
                                        {/* <td colSpan="5" className="text-left">{JSON.stringify(subject)}</td> */}
                                        <td key={'td_' + subject.subject} className="text-left">{subject.subject}</td>
                                        <td className="text-center" >
                                            {subject.lstDaysOff && subject.lstDaysOff.map((obj, dayIdx) => {
                                                return <input
                                                    key={tblKey + '_inp_' + subject.subjectId + '_' + dayIdx + '_' + (obj ? Math.round(Math.random() * 99999) : '0')}
                                                    className="text-center"
                                                    dataKey={tblKey + '_inp_' + subject.subjectId + '_' + dayIdx + '_' + (obj ? Math.round(Math.random() * 99999) : '0')}
                                                    style={{ margin: '0 2px' }}
                                                    type="checkbox"
                                                    defaultChecked={obj}
                                                    onChange={(e) => { handleDaysOff(dayIdx, subject.subjectId, e.target.checked) }} />
                                            })}
                                        </td>
                                        <td className="text-center">
                                            {
                                                subject.lstPeriodsOff &&
                                                subject.lstPeriodsOff.map((obj, periodIdx) => {
                                                    return <input
                                                        type="checkbox"
                                                        style={{ margin: '0 4px' }}
                                                        key={tblKey + '_p_' + subject.subjectId + '_' + periodIdx + '_' + (obj ? Math.round(Math.random() * 99999) : '0')}
                                                        dataKey={tblKey + '_p_' + subject.subjectId + '_' + periodIdx + '_' + (obj ? Math.round(Math.random() * 99999) : '0')}
                                                        className="text-center"
                                                        defaultChecked={obj}
                                                        onChange={(e) => handlePeriodsOff(periodIdx, subject.subjectId, e.target.checked)}
                                                        disabled={lstPeriod[periodIdx].disabled} />

                                                })}
                                        </td>
                                        <td className='text-center'>
                                            <span className="glyphicon glyphicon-floppy-disk" onClick={() => saveSubjectDaysPeriod(subject.subjectId)}></span>
                                            <span className="fa fa-refresh" onClick={() => resetSubjectDaysPeriods(subject.subjectId)}></span></td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div >
    );
}

export default SubjectConstraintTable;